<div class="layout-topbar">
  <a class="layout-topbar-logo" routerLink="">
    <img
      src="assets/img/brand/fusion_logo.png"
      [alt]="'fusion_platform' | translate"
      [title]="'fusion_platform' | translate"
    />
  </a>
  <ul class="layout-topbar-menu layout-topbar-user-dropdown list-none flex items-center ml-auto p-0 m-0">
    @if (showShadowSessionIndicator()) {
      <li class="list-none flex items-center mr-3" data-testid="shadow-session-indicator">
        <span
          class="inline-flex items-center gap-2 rounded-full border border-primary/25 bg-primary/5 px-3 py-1 text-sm text-primary"
          role="status"
          [attr.aria-label]="shadowSessionStatusText()"
          [attr.title]="shadowSessionStatusText()"
          [pTooltip]="shadowSessionStatusText()"
          tooltipPosition="bottom"
          [showDelay]="300"
        >
          <i class="pi pi-eye" aria-hidden="true"></i>
          <span class="hidden md:inline max-w-[16rem] lg:max-w-none truncate">
            {{
              'loggedInAsShadowSession'
                | translate: { organisation: shadowOrganisationName(), role: shadowRoleLabel() }
            }}
          </span>
        </span>
      </li>
    }
    <li class="list-none">
      <a
        class="flex items-center gap-2 cursor-pointer no-underline"
        id="userDropdown"
        data-testid="user-dropdown"
        role="button"
        (click)="rightmenu.toggle($event)"
      >
        <span class="mr-2 hidden lg:inline text-gray-400 medium">{{ userName() }}</span>
        <p-avatar
          [label]="userName() | firstLetter | uppercase"
          [style]="{ 'background-color': 'var(--primary-purple)', 'color': '#ffffff' }"
          size="large"
          shape="circle"
        />
      </a>
    </li>
  </ul>
  <button
    id="menubutton"
    #menubutton
    class="p-link layout-menu-button layout-topbar-button"
    (click)="layoutService.onMenuToggle()"
  >
    <i class="pi pi-bars"></i>
  </button>
</div>
<p-menu
  appendTo="body"
  #rightmenu
  [model]="items()"
  [popup]="true"
  class="layout-topbar-user-menu"
  data-testid="user-menu"
>
  <ng-template let-menuItem #item>
    @if (menuItem.label === 'Language') {
      <div class="layout-topbar-user-menu flex" (click)="$event.stopPropagation()">
        <span class="p-ripple p-menu-item-link {{ menuItem.icon }}" aria-hidden="true"></span>
        <p-select
          appendTo="body"
          [options]="languages() || []"
          [ngModel]="sessionLanguage()"
          (ngModelChange)="sessionLanguage.set($event)"
          optionLabel="endonym"
          optionValue="iso"
          [placeholder]="'language' | translate"
          [ariaLabel]="'language' | translate"
          (onChange)="onLanguageChange()"
        >
          <ng-template #item let-language>
            <span>
              {{ language.name }} ({{ language.endonym }})
              @if (language.default) {
                <span>(default)</span>
              }
            </span>
          </ng-template>
          <ng-template #selectedItem let-language>{{ language.endonym }}</ng-template>
        </p-select>
      </div>
    } @else {
      <a
        pRipple
        class="p-menu-item-link"
        [class.highlight]="menuItem.styleClass === 'highlight'"
        [routerLink]="menuItem.routerLink"
        [attr.data-testid]="menuItem.id"
        (click)="onMenuItemClick($event, menuItem)"
      >
        <span class="p-menu-item-icon {{ menuItem.icon }}" aria-hidden="true"></span>
        <span class="p-menu-item-label" [attr.data-testid]="menuItem.id">{{ menuItem.label | translate }}</span>
      </a>
    }
  </ng-template>
</p-menu>
<p-confirmDialog key="revertShadowConfirm" />
